document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('add-and-checkout-btn');
  const buttonLabel = button.querySelector('b');
  const originalText = buttonLabel.textContent;

  button.addEventListener('click', async function () {
    buttonLabel.textContent = 'Adding...';
    button.classList.add('is-loading'); // opcional para estilos
    button.style.pointerEvents = 'none'; // desactiva clics mientras procesa

    const variantInput = document.querySelector('product-form.product-form input[name="id"]');
    if (!variantInput) {
      console.error('❌ No se encontró input[name="id"]');
      buttonLabel.textContent = originalText;
      button.style.pointerEvents = '';
      return;
    }

    const variantId = variantInput.value;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) throw new Error('Error al agregar');

      buttonLabel.textContent = 'Checkout Loading...';

      setTimeout(() => {
        buttonLabel.textContent = originalText;
        button.style.pointerEvents = '';
        window.location.href = '/checkout';
      }, 1000);
    } catch (error) {
      console.error('❌ Error:', error);
      buttonLabel.textContent = 'Error ❌';
      setTimeout(() => {
        buttonLabel.textContent = originalText;
        button.style.pointerEvents = '';
      }, 1000);
    }
  });
});
